import * as React from 'react'
import styles from './AffirmLineBF.module.scss'

interface AffirmLineProps {
	currentPrice: number
	newFinancing: boolean
	monthlyPrice: string
	className?: string
	id?: string
}

const AffirmLine: React.FC<AffirmLineProps> = (props) => {
	const loadAffirm = () => {
		if ((window as any).affirm && (window as any).affirm.ui && (window as any).affirm.ui.refresh) {
			;(window as any).affirm.ui.refresh()
		}
	}

	React.useEffect(
		function refreshAffirm() {
			if ((window as any).affirm !== undefined) {
				if ((window as any).affirm.ui !== undefined) {
					if ((window as any).affirm.ui.refresh !== undefined) {
						;(window as any).affirm.ui.refresh()
					} else {
						loadAffirm()
					}
				} else {
					loadAffirm()
				}
			}

			if ((window as any).pb_prequalify_init !== undefined) {
				;(window as any).pb_prequalify_init()
			}
		},
		[props.currentPrice, props.id]
	)

	return (
		<>
			<p className={styles.monthly_price}>
				<span>{props.monthlyPrice}</span>/mo
			</p>
		</>
	)
}

export default AffirmLine
